import type { SerializedEditorState } from "lexical";

export type EmailDesignTemplateSettings = {
  backgroundColour?: string;
};

export type SerialisedLexicalEditorDesign = SerializedEditorState & {
  type?: "lexical";
  template?: EmailDesignTemplateSettings;
};

export type SerialisedMarkdownEditorDesign = {
  type: "markdown";
  markdown: string;
  template?: EmailDesignTemplateSettings;
};

export type SerialisedEditorDesign = SerialisedLexicalEditorDesign | SerialisedMarkdownEditorDesign;

export const isMarkdownDesign = (
  design: SerialisedEditorDesign | undefined,
): design is SerialisedMarkdownEditorDesign =>
  design !== undefined && "type" in design && design?.type === "markdown";
